var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"click"},on:{"click":function($event){$event.preventDefault();return _vm.logout($event)}}},[_vm._v("Logout")])}
var staticRenderFns = []

export { render, staticRenderFns }